import React from 'react';
import Loading from '../../../../../../Components/Loading';
import useRootWorkplaceInfo from '../../../../Hooks/useRootWorkplaceInfo';
// @ts-ignore
import styles from './ManagerFinance.module.scss';
import BankAccountSetup from '../BankAccountSetup/BankAccountSetup';
import BillingAddressSetupWrapper from '../../../../../../Components/Manager/Components/Finance/BillingAddress/BillingAddressSetupWrapper';
import Text from '../../../../../../Components/Base/Text/Text';
import { useManagerContext } from '../../../../Services/ManagerContext';

const ManagerFinance: React.FC = () => {
	const { isLoading, rootWorkplace } = useRootWorkplaceInfo();
	const { isSuperAdmin } = useManagerContext();

	if (isLoading) {
		return <Loading />;
	}

	return (
		<div className={styles.wrapper}>
			<Text tx='base.bankAccount' className={styles.title} />
			<BankAccountSetup rootWorkplaceId={rootWorkplace.id} />
			<hr />
			<Text tx='base.workplaceBillingAddress' className={styles.title} />
			<BillingAddressSetupWrapper isSuperAdmin={isSuperAdmin} />
		</div>
	);
};

export default ManagerFinance;
